import {
  GET_BRANCHLIST_SUCCESS,
  GET_BRANCHLIST_FAILED,
  GET_BRANCHLIST_INVALID_WALLET_ID,
  GET_BRANCHLIST_INVALID_TOKEN,
  RESET_GET_BRANCHLIST,
  LOADING_GET_BRANCHLIST,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  notFound: false,
  invalidToken: false,
  branchList: [],
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_BRANCHLIST:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: false,
        status: "",
        networkError: "",
      };

    case GET_BRANCHLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        notFound: false,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BRANCHLIST_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: true,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BRANCHLIST_INVALID_WALLET_ID:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: true,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BRANCHLIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        notFound: false,
        invalidToken: false,
        branchList: [].concat(action.payload.branchList),
        networkError: "",
      };
    }

    case RESET_GET_BRANCHLIST:
      return (state = initialState);

    default:
      return state;
  }
};
